export const extractNumericId = (id) => {
    if (id === null || id === undefined) {
      console.warn('extractNumericId received null or undefined id:', id);
      return null;
    }
    const idStr = typeof id === 'string' ? id : String(id);
    const match = idStr.match(/^(\d+)/);
    if (!match) {
      console.warn('extractNumericId could not extract numeric ID from:', idStr);
    }
    return match ? match[1] : null;
  };